import React from "react"
import PropTypes from "prop-types"


const Html = ({ html }) => {
  const markup = { __html: html }

  return (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={markup} />
  )
}

Html.propTypes = {
  html: PropTypes.string.isRequired,
}

export default Html
